export * from './ProductsCarousel'

export type { ProductsCarouselProps } from './ProductsCarousel.types'
